<template>
  <b-input
    ref="refInput"
    :model-value="value"
    :type="type"
    :expanded="expanded"
    :password-reveal="passwordReveal"
    :loading="loading"
    :icon-pack="iconPack"
    :icon="icon"
    :icon-right="iconRight"
    :maxlength="maxlength"
    :custom-class="customClass"
    :autocomplete="autocomplete"
    :use-html5-validation="useHtml5Validation"
    :rows="rows"
    :disabled="disabled"
    :placeholder="placeholder"
    @update:model-value="onInput"
    @focus="onFocus"
    @blur="onBlur"
  />
</template>

<script>
export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'InputView',
  emits: ['focus', 'blur', 'keyup', 'input'],
  props: {
    value: {
      type: [String, Number],
      default: undefined
    },
    type: {
      type: String,
      default: 'text'
    },
    expanded: {
      type: Boolean,
      default: false
    },
    passwordReveal: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    useHtml5Validation: {
      type: Boolean,
      default: true
    },
    iconPack: {
      type: String
    },
    icon: {
      type: String
    },
    iconRight: {
      type: String
    },
    maxlength: {
      type: [Number, String]
    },
    customClass: {
      type: String
    },
    autocomplete: {
      type: String
    },
    placeholder: {
      type: String
    },
    rows: {
      type: [Number, String],
      default: null
    }
  },
  methods: {
    getInputEl() {
      const refInput = this.$refs?.refInput;

      if (!refInput) {
        return null;
      }

      return this.type === 'textarea' ? refInput.$refs?.textarea : refInput.$refs?.input;
    },
    onFocus(...args) {
      this.$emit('focus', ...args);
    },
    onBlur(...args) {
      this.$emit('blur', ...args);
    },
    onKeyUp(...args) {
      this.$emit('keyup', ...args);
    },
    onInput(...args) {
      this.$emit('input', ...args);
    },
    focus() {
      this.getInputEl()?.focus();
    }
  },
  mounted() {
    this.getInputEl()?.addEventListener('keyup', this.onKeyUp);
  },
  beforeUnmount() {
    this.getInputEl()?.removeEventListener('keyup', this.onKeyUp);
  }
};
</script>
